<template>
    <b-modal
        lazy
        title-tag="h2"
        title="Communication"
        :visible="isOpen"
        ok-only
        ok-title="Close"
    >
        <div v-html="content" />
    </b-modal>
</template>

<script>
export default {
    name: "modalCommunicationContent",
    data() {
        return {
            isOpen: false,
            content: ""
        };
    },
    methods: {
        open(content) {
            this.isOpen = true;
            this.content = content;
        },
        close() {
            this.isOpen = false;
        }
    }
};
</script>
